import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ITrade } from "../interface/trade/ITrade";
import ITradeBasicInfo from "../interface/trade/ITradeBasicInfo";
import IQueryTradesBasicInfo from "../queryStrings/IQueryTradesBasicInfo";
import IWorkflowBasicInfo from "../interface/trade/IWorkflowBasicInfo";

enum TradeSearchServiceEnum {
  getBasicInfo = "/basic-info",
  getTradeDetail = "/detail?",
  searchTrades = "/filter"
}

export default class TradeSearchService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade/search");
  }

  public getTradesBasicInfo = async (queryString: IQueryTradesBasicInfo): Promise<IWorkflowBasicInfo> => await this.POST(`${TradeSearchServiceEnum.getBasicInfo}`, queryString);
  public getTradeDetail = async (tradeId: number): Promise<ITrade> => await this.GET(TradeSearchServiceEnum.getTradeDetail + "id=" + tradeId);
  public searchTrades = async (query: string): Promise<ITradeBasicInfo[]> => await this.POST(TradeSearchServiceEnum.searchTrades, { query });
}
